import { render, staticRenderFns } from "./multiCard.vue?vue&type=template&id=3c52469c&scoped=true"
import script from "./multiCard.vue?vue&type=script&lang=js"
export * from "./multiCard.vue?vue&type=script&lang=js"
import style0 from "./multiCard.vue?vue&type=style&index=0&id=3c52469c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c52469c",
  null
  
)

export default component.exports